// resourceUrlTypeConstants.js

export const API = 'api';
export const WATCH = 'watch';
export const PUBLIC = 'public';
export const RSS_FEED = 'rssFeed';
